import React, { FC } from 'react';
import { css } from '@emotion/core';

import { SPACE_COZY } from '@/styles';

const RightAlign: FC = props => (
  <div
    css={css`
      text-align: right;
      margin-left: ${SPACE_COZY}px;
    `}
    {...props}
  />
);
export default RightAlign;
